import React from 'react'
// libs
import { change } from 'redux-form'
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Forms } from 'constants/forms'
import { Modals } from 'constants/modals'
import { PANEL_STYLES } from '../UserData'
// themes
import { colors } from 'themes/index'
// views
import { Status, StatusText } from 'components/PageComponents/Account/shared/views'

const BTN_STYLE = { marginTop: 20, marginRight: 10 }

interface TwoFactorSettingsProps {
  isAdmin: boolean
  userTotpEnabled?: boolean
}

const TwoFactorSettings: React.FC<TwoFactorSettingsProps> = ({ isAdmin, userTotpEnabled }) => {
  const router = useRouter()
  const dispatch = useDispatch()

  const { showModal: showAdminResetModal } = useShowModal({
    modalType: Modals.TWO_FACTOR_ADMIN_RESET_MODAL
  })

  const userId = router.query.id as string
  const companyId = router.query.companyId as string

  const reset2Fa = () => {
    dispatch(change(Forms.USER_DETAILS_EDIT_FORM, 'totpEnabled', false))
  }

  return (
    <AccordionOrigin>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>
        Two-Factor Authentication
      </AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <>
          <Status>
            Status:
            <StatusText enabled={userTotpEnabled}>{userTotpEnabled ? ' Enabled' : ' Disabled'}</StatusText>
          </Status>

          {userTotpEnabled && isAdmin && (
            <Button
              layout={BUTTON_LAYOUTS.PURPLE}
              onClick={() =>
                showAdminResetModal({
                  userId,
                  companyId,
                  refetch: reset2Fa
                })
              }
              style={{ ...CREATE_BUTTON_STYLE, ...BTN_STYLE }}>
              Reset User's 2FA
            </Button>
          )}
        </>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default TwoFactorSettings
